// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1735":"c0195d9c2f54f352","1869":"02ea52c29774191e"}[chunkId] + ".css";
};